var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNewCardImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5445 63.1509C76.6869 63.1509 70.8921 68.9457 70.8921 75.8033C70.8921 82.6608 76.6869 88.4556 83.5445 88.4556C90.4021 88.4556 96.1968 82.6608 96.1968 75.8033C96.1968 68.9457 90.4021 63.1509 83.5445 63.1509ZM83.5445 82.1294C80.1758 82.1294 77.2183 79.172 77.2183 75.8033C77.2183 72.4346 80.1758 69.4771 83.5445 69.4771C86.9132 69.4771 89.8707 72.4346 89.8707 75.8033C89.8707 79.172 86.9132 82.1294 83.5445 82.1294Z",
    fill: "#ECF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.849 53.6617H100.67L92.107 45.0992C91.8138 44.8049 91.4652 44.5715 91.0814 44.4124C90.6976 44.2533 90.2862 44.1718 89.8707 44.1724H77.2183C76.8029 44.1718 76.3914 44.2533 76.0076 44.4124C75.6238 44.5715 75.2753 44.8049 74.982 45.0992L66.4195 53.6617H58.2398C54.7509 53.6617 51.9136 56.4989 51.9136 59.9878V94.7819C51.9136 98.2708 54.7509 101.108 58.2398 101.108H108.849C112.338 101.108 115.175 98.2708 115.175 94.7819V59.9878C115.175 56.4989 112.338 53.6617 108.849 53.6617ZM58.2398 94.7819V59.9878H67.7291C68.5704 59.9878 69.3739 59.6557 69.9654 59.0611L78.5279 50.4986H88.5612L97.1237 59.0611C97.4169 59.3554 97.7655 59.5888 98.1493 59.7478C98.5331 59.9069 98.9446 59.9884 99.36 59.9878H108.849L108.856 94.7819H58.2398Z",
    fill: "#ECF2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.794 54.3275H41.1202V35.3489H50.6094L37.9571 19.5334L25.3047 35.3489H34.794V54.3275Z",
    fill: "#ECF2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2619 63.8167H12.6524V41.675H6.32617V63.8167C6.32617 67.3056 9.16347 70.1429 12.6524 70.1429H63.2619C66.7508 70.1429 69.5881 67.3056 69.5881 63.8167V41.675H63.2619V63.8167Z",
    fill: "#ECF2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30029 108.375L91.7861 15.75L104.096 0L123 13.125L19.6872 123L4.30029 108.375Z",
    fill: "#F6F9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.86 18.2018L25.5772 103.854",
    stroke: "#ECF2FF",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCardImage);
export default __webpack_public_path__ + "static/media/addNewCardImage.8598b3a9abdaaa64b00db16b834e513f.svg";
export { ForwardRef as ReactComponent };